import api from '../utilities/api';

const getVoteStatistics = (editionId) => {
  return api.get(`/bo/editions/${editionId}/external/statistics/`);
};

export { getVoteStatistics };
